import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from "../app/store";
import { cityApi } from '../services/cityApi';

export interface citiesState {
  totalRecords: number | null;
  data: [] | null | any;
  totalPages: number | null;
  currentPage: number | null;
  loading: boolean;
  error: string | null;
}

const initialState: citiesState = {
  totalRecords: null,
  data: null,
  totalPages: null,
  currentPage: null,
  loading: false,
  error: null,
};

export const citiesSlice = createSlice({
  name: 'city',
  initialState,
  reducers: {
    setCities: (state: any, action: any) => {
      state.data = action.payload.data;
      state.currentPage = action.payload.currentPage;
      state.totalPages = action.payload.totalPages;
      state.totalRecords = action.payload.totalRecords;
    },
    addNewCities: (state: any, action: any) => {
      state.data = [action.payload.data, ...state.data];
    },
    reset: (state) => {
      state = initialState;
    },
  },
});

export const { setCities, addNewCities, reset } = citiesSlice.actions;
export const getCities = (state: RootState) => state.city.data;
export const getCitiesLoading = (state: RootState) => state.city.loading;
export const getCitiesError = (state: RootState) => state.city.error;
export const getCitiesTotalRecord = (state: RootState) => state.city.totalRecords;

export default citiesSlice.reducer;